import { render, staticRenderFns } from "./StepsInsert.vue?vue&type=template&id=04ba36c8&scoped=true"
import script from "./StepsInsert.vue?vue&type=script&lang=js"
export * from "./StepsInsert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ba36c8",
  null
  
)

export default component.exports